<footer class="base_footer">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-8 col-sm-12">
                <p class="text-left">Real World Finance Inc - 131 Continental Dr, Ste 301, Newark, DE 19713, USA.</p>
            </div>
            <div class="col-lg-4 col-sm-12 text-left text-md-right">
                <a href="assets/images/terms&condition.pdf" target="_blank" class="text-left text-md-right">Terms & Conditions</a>
            </div>

        </div>
    </div>
</footer>